var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"message"}},[_c('top',{attrs:{"topIndex":9}}),_c('div',{staticClass:"mian",style:({ height: _vm.mianH + 'px' })},[_c('left',{attrs:{"leftIndex":9}}),_c('div',{staticClass:"contactUs"},[_c('div',{staticClass:"flex",staticStyle:{"height":"100%"}},[_c('ContactUsList'),_c('ContactUsRight')],1)])],1),_c('RightDisplayArea')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }